import { useState, createContext } from "react";

import {
  AccountContainer,
  ExternalContainer,
  TitleSubtitle,
} from "../../components/Account/reusables";
import { GoogleIcon, FacebookIcon, AppleIcon } from "../../assets/accountIcons";
import { SocialType } from "./types";
import { useSocialLogin } from "../../context/SocialLoginConnect";
import { useModal } from "../../context/ModalContext";

export const SocialConnect = () => {
  const { googleLoginEnabled, toggleGoogleLogin } = useSocialLogin();
  const { openLoginModal } = useModal();

   const handleGoogleToggle = async () => {
    await toggleGoogleLogin();
  };
  const linkedAccounts = [
    ...(googleLoginEnabled
      ? [
          {
            title: "Google",
            enabled: googleLoginEnabled,
            toggle: handleGoogleToggle,
          },
        ]
      : []),
  ];

  const unlinkedAccounts = [
    ...(!googleLoginEnabled
      ? [
          {
            title: "Google",
            enabled: googleLoginEnabled,
            toggle: handleGoogleToggle,
          },
        ]
      : []),
  ];
  return (
    <ExternalContainer>
      <AccountContainer headerText="Social Connect">
        <div className="col-6">
          {linkedAccounts.length > 0 && (
            <SocialAccount
              heading="Linked Accounts"
              CTA="Unlink account"
              content={linkedAccounts}
            />
          )}
          {unlinkedAccounts.length > 0 && (
            <SocialAccount
              heading="Unlinked Accounts"
              CTA="Link account"
              content={unlinkedAccounts}
            />
          )}
        </div>
      </AccountContainer>
    </ExternalContainer>
  );
};

const SocialAccount = ({ heading, CTA, content }: SocialType) => {
  return (
    <div className="col-4">
      <span className="lt-sm-normal-black dark:text-white">{heading}</span>
      {content.map((item, index) => (
        <div key={index} className="row-3 p-2 rounded-lg">
          {item.title === "Facebook" ? (
            <FacebookIcon />
          ) : item.title === "Apple" ? (
            <AppleIcon />
          ) : (
            <GoogleIcon />
          )}
          <div className="row-4 items-center justify-between w-full">
            <TitleSubtitle
              title={item.title}
              subtitle={
                heading === "Linked Accounts"
                  ? `You've signed in with ${item.title} account`
                  : ""
              }
            />
            <div className="row-4 items-center">
              <span className="satoshi-xs-semibold-toggleBG-dark dark:text-white">
                {CTA}
              </span>
              <ToggleSwitch isOn={item.enabled} onToggle={item.toggle} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

const ToggleSwitch = ({
  isOn: propIsOn,
  onToggle,
}: {
  isOn?: boolean;
  onToggle?: () => void;
}) => {
  const [internalOn, setInternalOn] = useState(false);

  const isOn = typeof propIsOn === "boolean" ? propIsOn : internalOn;

  const handleToggle = () => {
    if (onToggle) {
      onToggle();
    } else {
      setInternalOn((v) => !v);
    }
  };

  return (
    <button
      onClick={handleToggle}
      className={`w-14 h-7 flex items-center rounded-full p-1 transition ${
        isOn ? "bg-pry-500" : "bg-border-dark"
      }`}
    >
      <div
        className={`w-6 h-6 bg-white rounded-full shadow-md transform transition ${
          isOn ? "translate-x-6" : "translate-x-0"
        }`}
      />
    </button>
  );
};
